import { ChangeDetectionStrategy, Component, inject, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { IconComponent } from '@libs/components/icons';
import { ComponentsIconsStyle, IconName, NavItemModel } from '@libs/shared/models';
import { RouteHistoryService } from '@libs/shared/services';
import { ButtonComponent, ButtonLinkComponent } from '../../actions';
import { IconButtonComponent } from '../../actions/icon-button';

@Component({
  selector: 'ui-page-header',
  imports: [IconButtonComponent, ButtonComponent, IconComponent, ButtonLinkComponent, MatTooltip],
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.with-subtitle]': '!!subtitle()',
    '[class.boxed]': 'boxed()',
  },
})
export class PageHeaderComponent {
  private readonly routeHistoryService: RouteHistoryService = inject(RouteHistoryService);

  public subtitle: InputSignal<string | undefined> = input();
  public showBackButton: InputSignal<boolean> = input(true);
  public routeToIgnoreForBackNavigation: InputSignal<string> = input('');

  public boxed: InputSignal<boolean> = input(true);

  public actionIcon: InputSignal<IconName | undefined> = input();
  public actionIconStyle: InputSignal<ComponentsIconsStyle> = input<ComponentsIconsStyle>('light');
  public actionText: InputSignal<string> = input('');
  public actionLink: InputSignal<NavItemModel | undefined> = input();
  public actionClicked: OutputEmitterRef<void> = output();

  public goBack(): void {
    this.routeHistoryService.back(this.routeToIgnoreForBackNavigation());
  }
}
